
import { createSelector } from '@reduxjs/toolkit';
import {RootState} from "../store.ts";
import {InputEnum} from "../../../shared/types/EffectType.ts";

const selectPromts = (state: RootState) => state.generation.prompts;

export const selectTextPrompt = createSelector(
    [selectPromts],
    (promts) => promts.find((p) => p.type === InputEnum.TextPrompt)
);
